import React, { useCallback, useContext, useEffect, useState } from 'react'
import { WrapDataGrid } from 'components/DataGrid/Style'
import { NormalizerContext } from './NormalizerContext'
import { assessmentsHooks } from 'pages/School/Assessments'
import { NormalizerStyles } from './Style'
import { Divider } from '@mui/material'
import { thirdly2 } from 'styles/theme'
import { LightButton, Space } from 'styles/GlobalStyle'
import { ApplyDataConfirmation, normalizerHooks } from '.'
import { changeItem } from 'utils/array'
import { ScoreRatingItem } from '.'
import { useQueryClient } from '@tanstack/react-query'
import { isEmpty, isEqual } from 'lodash'
import { EmptyScreen } from '.'
import { useAlert } from 'components/Alerts/hooks'
import AssessmentFiltersHeader from 'pages/School/Assessments/AssessmentFiltersHeader'

const Normalizer = () => {
    const { methods, applyDataConfirmOpen, setLoadingData, loadingData, setApplyDataConfirmOpen, activeScoreItemStatus, activeScoreRatingIndex, setActiveScoreRatingIndex, stats, setStats, scoreRatingOptions, setScoreRatingOptions, assessmentFilters, setAssessmentFilters, scoreRatingSemesters, checkType } = useContext(NormalizerContext)
    const [openExitAlert, setOpenExitAlert] = useState(false)
    const headerItems = assessmentsHooks.useHeaderItems()
    const headerBtns = normalizerHooks.useHeaderBtns()
    const selectCheckType = normalizerHooks.useSelectCheckType()
    const queryClient = useQueryClient()
    const { setAlerts } = useAlert()

    const changeActiveScoreItem = useCallback((index) => {
        if (activeScoreRatingIndex != null && activeScoreItemStatus) {
            setApplyDataConfirmOpen(true)
        }
        else {
            if (isEqual(activeScoreRatingIndex, index))
                setActiveScoreRatingIndex(null)
            else {
                setActiveScoreRatingIndex(index)
                editScoreRatingOption(index, "showChildren")
            }
        }
    }, [activeScoreRatingIndex, activeScoreItemStatus])

    const editScoreRatingOption = useCallback((index, key) => {
        let scOptions = { ...scoreRatingOptions[index] }
        scOptions[key] = !scOptions[key]
        const nScoreRatingOptions = changeItem(scoreRatingOptions, index, scOptions)
        setScoreRatingOptions(nScoreRatingOptions)
    }, [scoreRatingOptions, stats])

    const refetchData = useCallback(async () => {
        setActiveScoreRatingIndex(null)
        setLoadingData(false)
        queryClient.removeQueries([checkType.queryKey])
        await scoreRatingSemesters.refetch()
        queryClient.invalidateQueries([checkType.queryKey])
    }, [checkType])

    const updateStats = useCallback((index, val) => {
        setStats(prevStats => {
            const nStats = changeItem(prevStats, index, val);
            return nStats;
        });
    }, [stats])

    useEffect(() => {
        return (() => {
            queryClient.removeQueries()
        })
    }, [])

    useEffect(() => {
        return (() => {
            // if (activeScoreItemStatus == "view")
            //     setAlerts(alerts.exitNormalator, true)
        })
    }, [activeScoreItemStatus])

    const Row = ({ index, style }) => {
        const scoreRating = scoreRatingSemesters.data[index];
        return (
            <div style={style}>
                <ScoreRatingItem
                    key={index}
                    graphKey={index}
                    changeActiveScoreItem={changeActiveScoreItem}
                    activeScoreRatingIndex={activeScoreRatingIndex}
                    editScoreRatingOption={editScoreRatingOption}
                    index={index}
                    scoreRating={scoreRating}
                    scoreRatingOptions={scoreRatingOptions[index]}
                    stats={stats[index]}
                    updateStats={(val) => updateStats(index, val)}
                />
            </div>
        );
    };

    return (
        <NormalizerStyles>
            <WrapDataGrid>
                <AssessmentFiltersHeader
                    searchLabel="הצג"
                    disabledSearch={
                        //select semester and year or select category
                        ((!assessmentFilters.category || !checkType) && (!assessmentFilters.semester || !checkType))
                        ||
                        isEmpty(assessmentFilters.methods)
                    }
                    refetchData={refetchData}
                    loading={scoreRatingSemesters.isFetching}
                    headerItems={[
                        headerItems.grade_of_allocation,
                        headerItems.semester,
                        {
                            ...headerItems.category,
                            multiple: false,
                        },
                        selectCheckType,
                        {
                            id: 0,
                            placeholder: "שיטה",
                            options: methods,
                            name: "methods",
                            component: "autoComplete",
                            multiple: true,
                        }
                    ]}
                    showLoading={true}
                    assessmentFilters={assessmentFilters}
                    setAssessmentFilters={setAssessmentFilters}
                />
                <Divider sx={{ borderColor: thirdly2 }} />
                <Space />
                <div className='sc-actions'>
                    <div className='sc-header-btns'>
                        {headerBtns.map((act, index) =>
                            <LightButton key={index} size="small" systemUI  {...act} />
                        )}
                    </div>
                </div>
                <Space />
                {/* <div className='sc-sections'>
                    <List
                        height={300} // גובה התצוגה
                        itemCount={scoreRatingSemesters.data?.length || 0}
                        itemSize={300}
                        width={'100%'} // רוחב התצוגה
                    >
                        {Row}
                    </List>
                </div> */}
                {(checkType && !loadingData) ?
                    <div className='sc-sections'>
                        {scoreRatingSemesters.data?.map((scoreRating, index) => {

                            return (
                                <ScoreRatingItem
                                    key={index}
                                    changeActiveScoreItem={changeActiveScoreItem}
                                    activeScoreRatingIndex={activeScoreRatingIndex}
                                    graphKey={index}
                                    editScoreRatingOption={editScoreRatingOption}
                                    index={index}
                                    scoreRating={scoreRating}
                                    scoreRatingOptions={scoreRatingOptions[index]}
                                    stats={stats[index]}
                                    updateStats={(val) => updateStats(index, val)}
                                />
                            )

                        })}
                    </div> :
                    <EmptyScreen />
                }
                {/* {loadingData && <CircularProgress />} */}
            </WrapDataGrid>
            {applyDataConfirmOpen && <ApplyDataConfirmation handleAlert={setApplyDataConfirmOpen} />}
        </NormalizerStyles>
    )
}

export default Normalizer